import { createSlice } from '@reduxjs/toolkit';
import { KEYS_ENUMS } from '../../enums/keys';
import { jwtDecode } from 'jwt-decode';

function safeDecode(token) {
  try {
    return token ? jwtDecode(token) : null;
  } catch {
    return null;
  }
}

function isTokenValid(token) {
  const payload = safeDecode(token);
  if (!payload?.exp) return Boolean(token);
  return Math.floor(Date.now() / 1000) < payload.exp;
}

const storedAccess = localStorage.getItem(KEYS_ENUMS.ACCESS_TOKEN) || '';
const storedRefresh = localStorage.getItem(KEYS_ENUMS.REFRESH_TOKEN) || '';
const decoded = safeDecode(storedAccess);
const initialState = {
  accessToken: storedAccess,
  refreshToken: storedRefresh,
  isAuth: isTokenValid(storedAccess),
  brands: decoded?.claim ?? [],
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth(state, action) {
      const { token, refresh_token, brands } = action.payload;
      console.log('token',token)
      console.log('reftoken',refresh_token)
      localStorage.setItem(KEYS_ENUMS.ACCESS_TOKEN, token);
      localStorage.setItem(KEYS_ENUMS.REFRESH_TOKEN, refresh_token);
      state.accessToken = token;
      state.refreshToken = refresh_token;
      state.isAuth = isTokenValid(token);
      const decoded = safeDecode(token);
      state.brands = Array.isArray(brands)
        ? brands
        : (decoded?.brands ?? []);
    },
    logout(state) {
      localStorage.removeItem(KEYS_ENUMS.ACCESS_TOKEN);
      localStorage.removeItem(KEYS_ENUMS.REFRESH_TOKEN);
      state.accessToken = '';
      state.refreshToken = '';
      state.isAuth = false;
      state.brands = [];
    },
  },
});

export const { setAuth, logout } = authSlice.actions;
export default authSlice.reducer;
